import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Dropdown, DropdownButton, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList } from '@fortawesome/pro-light-svg-icons';
import { useActivitySearchContext } from '../../context';
import PageNavigation from '../../../../components/pageNavigation';
import VocabularyClipboardModal from './vocabularyClipboardModal';
import CustomToast from '../../../../components/Toast';
import { useNavigate, useParams } from 'react-router';
import { useAddVocabulariesMutation } from '../../../../features/authentication/activitySearchApiSlice';
import AddQuestionsToExisting from '../../../questionsSearch/components/castleQuestionsSearch/components/questionResults/components/addQuestionsToExisting';
import { DataProvider } from '../../../assignments/DataContext';
import AddQuestionsToAssignment from '../../../questionsSearch/components/addQuestionsToAssignment';
import ActivityCreateContent from '../../../activities/components/ActivityCreateContent';
import ActivityTypes from '../../../../enums/activityTypes';

const VocabularyDetailsBar = ({
  pageCount,
  selectedPage,
  setSelectedPage,
  selectedVocabularies,
  setSelectedVocabularies,
  vocabulariesPerPage,
  getPagedCastleVocabulariesCall,
  setCurrentSearchData,
  setVocabulariesPerPage,
  setDateBasedKey,
  onRemove
}) => {
  const [showClipboardModal, setShowClipboardModal] = useState(false);
  const [disableVocabulariesPerPages, setDisableVocabulariesPerPages] = useState(false);  
  const [openOptionTileModal, setOpenOptionTileModal] = useState(false);
  const [dateBasedKey] = useState(new Date().getTime().toString());
  const context = useActivitySearchContext();
  const navigate = useNavigate();
  const { activityId } = useParams();
  const [addVocabularies] = useAddVocabulariesMutation();

  const handleSelectPage = (pageNumber) => {
    if (pageNumber == selectedPage) return;
    getPagedCastleVocabulariesCall({...context.apiParams, pageNumber: pageNumber, pageSize: vocabulariesPerPage });
    setSelectedPage(pageNumber);
  };

  const handleApplyFilters = (vocabulariesPerPage) => {
    var searchRequest = {...context.apiParams, pageSize: vocabulariesPerPage,};
    setCurrentSearchData({ ...searchRequest, searchType: 'filter' });
    getPagedCastleVocabulariesCall(searchRequest);
  };


  useEffect(() => {
    if (pageCount == 1) {
      setVocabulariesPerPage(100);
      setDisableVocabulariesPerPages(true);
    }
  }, [pageCount]);

  const handleClipBoard = () => {
    if (selectedVocabularies.length === 0)
      CustomToast('You currently do not have any vocabularies selected.', 'warning');
    else setShowClipboardModal(true);
  };

  const addVocabualries = () => {
    if (!selectedVocabularies || selectedVocabularies.length == 0) {
      CustomToast('Please select vocabularies to add', 'error');
      return;
    }
    if (selectedVocabularies.length > 100) {
      CustomToast('You can only select up to 100 vocabularies at a time', 'error');
      return;
    }
    if (activityId) {
      addVocabulariesToFlashcard(activityId);
    }
    else{
      setOpenOptionTileModal(true);
    }
  };

  const addVocabulariesToFlashcard = async (activityId) => {
    const selectedVocabulariesList = Object.values(selectedVocabularies).filter(q => !q.inAssignment).map(vocabulary => ({
      questionId: vocabulary.questionId,
      courseId: vocabulary.courseId
    }));
    var options = {
      id: activityId,
      vocabularies: selectedVocabulariesList
    };
    const response = await addVocabularies(options);
    if(!response.error){
      CustomToast('Selected Vocabularies are added', 'success');
      setSelectedVocabularies([]);
      navigate(`/assignments/flashcards/${activityId}/edit_activity`);
    }
  };

  const saveComponentAddToExisting = 
  <AddQuestionsToExisting
    key={'update' + dateBasedKey}
    handleSave={(id) => addVocabulariesToFlashcard(id)}
    handleCancel={() => setOpenOptionTileModal(false)}
    activityType={ActivityTypes.FlashCard} />;
  
  const saveComponentCreate = <DataProvider>
    <ActivityCreateContent
      key={'create' + dateBasedKey}
      showTitle={false}
      fromActivities={false}
      handleCancel={() => setOpenOptionTileModal(false)}
      onCreateSuccess={(id) => addVocabulariesToFlashcard(id)}
    />
  </DataProvider>;
  

  return (
    <>
      <div className='selectionDetailsBar mt-5'>
        <div className='selectionDetailsBar-main'>
          <div className='d-flex flex-row align-items-center selectionDetailsBar-item selectionDetailsBar-left'>
            <div className='d-flex align-items-center gap-2'>
              <span className='fw-bold'>Selected:</span>
              <span className='selectionTypeCount'>{selectedVocabularies.length}</span>
              <OverlayTrigger
                key="editToolTip"
                placement="top"
                overlay={<Tooltip className="custom-tooltip">View all selected vocabularies</Tooltip>}>
                <div className='selectionTypeCount questionsClipboard' onClick={handleClipBoard}><FontAwesomeIcon icon={faClipboardList} /></div>
              </OverlayTrigger>
            </div>
          </div>
          <div className='d-flex flex-row flex-wrap align-items-center gap-2 my-2 selectionDetailsBar-item selectionDetailsBar-controls'>
            <span>Vocabularies Per Page:</span>
            <DropdownButton 
              id='dropdown-pageCount-selection' 
              title={vocabulariesPerPage} 
              variant='castleDropdown' 
              style={{ pointerEvents: disableVocabulariesPerPages ? 'none' : 'auto' }}
              drop='down' 
              onSelect={(e) => {
                if (e === vocabulariesPerPage) return;
                setVocabulariesPerPage(e);
                handleApplyFilters(e);
              }}>
              {[25, 50, 75, 100].map((pageSize) => (
                <Dropdown.Item 
                  key={pageSize}
                  eventKey={pageSize} 
                  active={vocabulariesPerPage === pageSize}>
                  {pageSize}
                </Dropdown.Item>
              ))}
            </DropdownButton>
            <PageNavigation handleSelectPage={handleSelectPage} currentPage={selectedPage} pageCount={pageCount} />
            <div className='selectionDetailsBar-item selectionDetailsBar-add'>
              <Button variant='castleRed' onClick={()=> addVocabualries()}>Add Vocabularies</Button>
            </div>
          </div>
        </div>
      </div>

      {showClipboardModal &&
      <VocabularyClipboardModal
        isOpen={showClipboardModal}
        setShowClipboardModal={setShowClipboardModal}
        selectedVocabularies={selectedVocabularies}
        setSelectedVocabularies={setSelectedVocabularies}
        setDateBasedKey={setDateBasedKey}
        onRemove={onRemove}
      />
      }
      {openOptionTileModal &&
        <AddQuestionsToAssignment
          key={'component' + dateBasedKey}
          openOptionTileModal={openOptionTileModal}
          setOpenOptionTileModal={setOpenOptionTileModal}
          saveComponentCreate={saveComponentCreate}
          saveComponentAddToExisting={saveComponentAddToExisting}
          activityType={ActivityTypes.FlashCard}
        />
      }
    </>
  );
};

VocabularyDetailsBar.propTypes = {
  vocabulariesPerPage: PropTypes.number,
  setVocabulariesPerPage: PropTypes.func,
  selectedVocabularies: PropTypes.array,
  setSelectedVocabularies: PropTypes.func,
  selectedPage: PropTypes.number,
  setSelectedPage: PropTypes.func,
  pageCount: PropTypes.number,
  mapSearchResults: PropTypes.func,
  dateBasedKey: PropTypes.string,
  setDateBasedKey: PropTypes.func,
  keywords: PropTypes.string,
  setCurrentSearchData: PropTypes.func,
  getPagedCastleVocabulariesCall: PropTypes.func,
  onRemove: PropTypes.func
};

export default VocabularyDetailsBar;
